<template>
    <div class="exportModel">
      <div class="model-title">
        <div class="my-buttom tit-button" @click="derive">出入库记录导出</div>
      </div>
      <!-- <div class="model-detail">
        <div class="box-detail">
          <span class="box-title">项目名称：</span>
          <span class="box-content">{{dataDetail.projectName}}</span>
        </div>
      </div> -->
      <div class="model-use-his sysTable" style="margin-top:10px">
        <el-table :data="list" height="450px" v-loading="tLoading" style="width: 100%">
          <el-table-column type="index" label="序号" width="70" align="center">
          </el-table-column>
          <el-table-column prop="instrumentName" label="仪器设备名称" align="center" min-width="200">
          </el-table-column>
          <el-table-column prop="serialNumber" label="仪器编号" align="center" width="150">
          </el-table-column>
          <el-table-column align="center" label="出库领用记录">
            <el-table-column prop="lendCloseTime" label="领用时间" align="center" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.lendCloseTime">
                  {{scope.row.lendCloseTime}}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="beforeUseStates" width="120" align="center" label="仪器状态/正常√ 异常×" :render-header="renderheader">
              <template slot-scope="scope">
                <span v-if="scope.row.beforeUseStates == 0">
                  <i class="el-icon-check"></i>
                </span>
                <span v-else>
                  <i class="el-icon-close"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="borrowSignature" width="100" align="center" label="领用人">
              <template slot-scope="scope">
                <span v-if="scope.row.borrowSignature">
                  <img :src="scope.row.borrowSignature" alt="">
                </span>
                <span>
                  {{scope.row.borrowUserName}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="checkUser" width="120" align="center" label="仪器房经手人">
            </el-table-column>
          </el-table-column>
          <el-table-column align="center" label="入库归还记录">
            <el-table-column prop="returnCloseTime" label="归还时间" align="center" width="180">
              <template slot-scope="scope">
                <span v-if="scope.row.returnCloseTime">
                  {{scope.row.returnCloseTime}}
                </span>
                <span v-else>-</span>
              </template>
            </el-table-column>
            <el-table-column prop="afterUseStates" width="120" align="center" label="仪器状态/正常√ 异常×" :render-header="renderheader">
              <template slot-scope="scope">
                <span v-if="scope.row.afterUseStates == 0">
                  <i class="el-icon-check"></i>
                </span>
                <span v-else>
                  <i class="el-icon-close"></i>
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="returnSignatur" width="100" align="center" label="归还人">
              <template slot-scope="scope">
                <span v-if="scope.row.returnSignatur">
                  <img :src="scope.row.returnSignatur" alt="">
                </span>
                <span>
                  {{scope.row.returnUser}}
                </span>
              </template>
            </el-table-column>
            <el-table-column prop="checkUser" width="120" align="center" label="仪器房经手人">
            </el-table-column>
          </el-table-column>
        </el-table>
        <div class="resource-block">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
      </div>
      </div>
    </div>
  </template>
  
  <script>
  import { getRecordByInsId,exportByInsv2 } from "@/api/depotApi";
  export default {
    name: "exportModel",
    props: {
      dataModel:Object,
  },
    data() {
      return {
        list:[],
        current:1,
        total:0,
        size:10,
        dataDetail: {},
        tLoading: true,
      };
    },
    created() {},
    mounted() {
      this.getRecordByProject();
    },
    watch: {
      projectId() {
        this.getRecordByProject();
      },
    },
    methods: {
      handleSizeChange(page){
        this.size = page;
        this.getRecordByProject()
      },
      handleCurrentChange(page){
        this.current = page;
        this.getRecordByProject();
      },
      //获取使用记录
      getRecordByProject() {
     
        let self = this;
        self.tLoading = true;
        let data = {
          current: self.current,
          size:self.size,
          insId: this.dataModel.id,
        };
        getRecordByInsId(data)
          .then((res) => {
            if (res.code == 200) {
              self.dataDetail = res.data;
              self.list = res.data.insUseInfos.records
              self.total = res.data.insUseInfos.total;
            }
          })
          .finally(() => (self.tLoading = false));
      },
      //导出使用记录
      derive() {
        const params = {
          depotId: this.dataModel.depotId,
          projectId: this.dataModel.projectId,
          instrumentId: this.dataModel.id,
        };
        exportByInsv2(params).then((res) => {
          this.mixin.blobDownload(res.data,'出入库记录.docx');
        });
      },
 
      renderheader(h, { column, $index }) {
        return h("span", {}, [
          h("span", {}, column.label.split("/")[0]),
          h("br"),
          h("span", {}, column.label.split("/")[1]),
        ]);
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .exportModel {
    .model-title {
      
      text-align: center;
      .tit-button {
        float: right;
        margin-right: 1%;
        margin-bottom:10px;
      }
    }
    .model-detail {
      width: 100%;
      display: grid; //网格形式
      grid-template-columns: 45% 45%; //这里表明分为3列
      grid-gap: 10px; //每列的间隔
      .box-detail {
        height: 32px;
        line-height: 32px;
        padding: 6px 12px;
        border-radius: 6px;
        margin-right: 10px;
        .box-title {
          width: 35%;
        }
        .box-content {
          width: 65%;
        }
      }
    }
    .model-use-his /deep/ .el-table__body-wrapper::-webkit-scrollbar {
      display: none;
    }
    .model-bottom {
      margin-top: 20px;
    }
  }
  .resource-block{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
  }
  </style>
  


// WEBPACK FOOTER //
// src/views/Instrumentmanagemen/components/outPutPopModel.vue